import { MemoryStateCounterRepository } from "./memoryStateCounterRepository";
import { StateCounterQuery } from "../application/StateCounterQuery";
import { APIStateCounterRepository } from "./apiStateCounterRepository";

export function getStateCounterData(): StateCounterQuery {
  let scsd_1 = {
    company_id:1,
    company_vat:'vat1',
    company_name:'Company 1',
    sd_id:1,
    booked_count:10,
    error_count:10,
    deleted_count:10,
    booked_deleted_count:10,
    pending_count:10,
    pending_sync_count:10,
    pending_review_count:10,
    accounting_count:10,
    error_accounting_count:10,
  }
  let scsd_2 = {
    company_id:2,
    company_vat:'vat2',
    company_name:'Company 2',
    sd_id:1,
    booked_count:9,
    error_count:9,
    deleted_count:9,
    booked_deleted_count:9,
    pending_count:9,
    pending_sync_count:10,
    pending_review_count:10,
    accounting_count:10,
    error_accounting_count:10,
  }
  let scsd_3 = {
    company_id:2,
    company_vat:'vat3',
    company_name:'Company 3',
    sd_id:2,
    booked_count:9,
    error_count:8,
    deleted_count:0,
    booked_deleted_count:9,
    pending_count:9,
    pending_sync_count:10,
    pending_review_count:10,
    accounting_count:10,
    error_accounting_count:10,
  }
  const repository = new MemoryStateCounterRepository([scsd_1,scsd_2,scsd_3]);
  return new StateCounterQuery(repository);
}

export function getStateCounterDataApi(): StateCounterQuery {
  const repository = new APIStateCounterRepository();
  return new StateCounterQuery(repository);
}
